import { z } from 'zod';
import { HexColorSchema, deletedFilterFields, refineDeletedFilterMutualExclusion } from './common.js';
/**
 * Strict (CTSK-445) — unknown keys are rejected with 400
 * VALIDATION_ERROR naming the offending key, instead of Zod's default
 * silent strip. Class-fix for the CTSK-427 silent-drop bug (memory
 * feedback_zod_field_name_silent_drop).
 */
export const StorageContainerCreateSchema = z.object({
    name: z.string().min(1).max(120),
    slug: z.string().min(1).max(64).regex(/^[a-z0-9][a-z0-9-]*$/, 'lowercase letters, digits and hyphens').optional(),
    description: z.string().max(1000).nullable().optional(),
    color: HexColorSchema.nullable().optional(),
    icon: z.string().max(32).nullable().optional(),
    parentId: z.string().nullable().optional(),
}).strict();
// .strip() restores Zod's default unknown-key tolerance for PATCH —
// CTSK-445 made Create strict, and .partial() would otherwise inherit
// `unknownKeys: "strict"`. Patch semantics deliberately unchanged.
export const StorageContainerPatchSchema = StorageContainerCreateSchema.partial().strip();
// CTSK-388 (Phase 2 of CTSK-385) — first list-query schema for storage
// containers. `GET /storage-containers` previously hard-coded an
// unconditional `isNull(deletedAt)` filter with no override; this makes
// that filter conditional on the new params.
export const StorageContainersListQuerySchema = z
    .object({
    ...deletedFilterFields,
})
    .superRefine(refineDeletedFilterMutualExclusion);
//# sourceMappingURL=storage-container.js.map